import * as React from "react";
import {
  TextField,
  Button,
  Stack,
  InputAdornment,
  Checkbox,
  Typography,
  Box,
} from "@mui/material";
import { Check, Save } from "@mui/icons-material";
import ModalUI from "../UI/ModalUI";
import useReportStore from "../../store/zustandStore/reportZs";
import useChapterStore from "../../store/zustandStore/chapterZs";

const ChapterModalEditor = (props) => {
  const { createChapterZs, updateChapterZs } = useChapterStore();
  const { data, isstatusnew, open, reportId, chapterLength } = props;

  const [state, setState] = React.useState({
    title: "",
    order: chapterLength + 1,
    reportId: reportId,
  });
  const [errorValues, setErrorValues] = React.useState([]);

  React.useEffect(() => {
    setErrorValues([]);
    setState({
      id: data.id ? data.id : "",
      title: data.title ? data.title : "",
      order: data.order ? data.order : chapterLength + 1,
      reportId: data?.reportId ? data?.reportId : reportId,
    });
  }, [data, open]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState({ ...state, [name]: value ? value : "" });
  };

  const saveChapter = () => {
    var initialError = [];
    Object.keys(state).map(function (key, index) {
      if (state[key] !== "" || Object.keys(state[key]).length !== 0) {
      } else {
        initialError.push(key);
      }
    });

    setErrorValues(initialError);

    var initialErrorTemp = [];
    initialErrorTemp = initialError.filter(
      (item) => item !== "id" && item !== "reportId"
    ); // remove id item

    if (initialErrorTemp.length === 0) {
      if (isstatusnew) {
        const { id, ...newChapter } = state;
        createChapterZs(newChapter);
      } else {
        updateChapterZs(state);
      }
      props.onClose();
    }
  };

  const checkError = (item) => {
    if (errorValues.find((element) => element === item)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <ModalUI {...props}>
      <Stack spacing={2}>
        <TextField
          name="title"
          autoComplete="off"
          id="title"
          variant="outlined"
          error={checkError("title")}
          helperText={checkError("title") ? "Titulli është i detyruar" : null}
          InputProps={{
            startAdornment: (
              <InputAdornment
                sx={{
                  "&.MuiInputAdornment-root": {
                    minWidth: "100px",
                  },
                }}
                position="start"
              >
                Titull
              </InputAdornment>
            ),
          }}
          value={state.title}
          onChange={handleInputChange}
        />
      </Stack>
      <Stack spacing={2}>
        <TextField
          name="order"
          autoComplete="off"
          id="order"
          number
          variant="outlined"
          error={checkError("order")}
          helperText={checkError("order") ? "Rendi është i detyruar" : null}
          InputProps={{
            startAdornment: (
              <InputAdornment
                sx={{
                  "&.MuiInputAdornment-root": {
                    minWidth: "100px",
                  },
                }}
                position="start"
              >
                Rendi
              </InputAdornment>
            ),
          }}
          value={state?.order}
          onChange={handleInputChange}
        />
      </Stack>
      <Stack sx={{ display: "flex", width: "100%" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "primary.dark",
            display: "flex",
            marginTop: "40px",
          }}
          startIcon={<Save />}
          onClick={saveChapter}
        >
          {isstatusnew ? "Shto" : "Ndrysho"}
        </Button>
      </Stack>
    </ModalUI>
  );
};
export default ChapterModalEditor;
